// WAB PDP Fix v2
(function(){
  function applyDotStyles(){
    if(!window.matchMedia('(max-width:749px)').matches) return;
    var dots = document.querySelectorAll('.pdp-gallery-dots__dot');
    if(!dots.length) return;
    dots.forEach(function(d){
      if(d.classList.contains('is-active')){
        d.style.cssText = 'background:#111 !important;width:30px !important;height:8px !important;transform:none !important;opacity:1 !important;flex-basis:30px !important';
      } else {
        d.style.cssText = 'background:#cfcfcf !important;width:8px !important;height:8px !important;transform:none !important;opacity:1 !important;flex-basis:8px !important';
      }
    });
  }
  function init(){
    applyDotStyles();
    setInterval(applyDotStyles, 300);
    var obs = new MutationObserver(applyDotStyles);
    obs.observe(document.body, {attributes:true, subtree:true, attributeFilter:['class']});
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Fix barrido de la galería al cambiar de variante.
  // El navegador puede tardar un tiempo variable e impredecible en asentar el
  // scroll del carril en la posición correcta tras el reorder del DOM (a veces
  // pasa por una posición intermedia/vieja antes de corregirse) — intentar
  // controlar exactamente qué valor de scroll está activo en cada instante
  // resultó frágil e inconsistente entre cargas. Solución robusta: ocultar el
  // carril en cuanto empieza el cambio de variante, forzar la posición final
  // correcta de un plumazo cuando el proceso termina, y revelarlo recién
  // entonces — así nunca se ve ningún estado intermedio, sea cual sea.
  (function(){
    var rail = null;
    var changing = false;
    var closeTimer = null;
    var pendingLeft = 0;
    var origScrollTo = Element.prototype.scrollTo;

    function getRail(){
      if (!rail || !rail.isConnected) rail = document.querySelector('.product__media-list');
      return rail;
    }

    function hideRail(r){
      r.style.setProperty('transition', 'none', 'important');
      r.style.setProperty('opacity', '0', 'important');
    }
    function revealRail(r){
      r.style.setProperty('transition', 'opacity .18s ease', 'important');
      r.style.setProperty('opacity', '1', 'important');
      setTimeout(function(){
        r.style.removeProperty('transition');
        r.style.removeProperty('opacity');
      }, 250);
    }

    function openWindow(){
      var r = getRail();
      if (r) hideRail(r);
      changing = true;
      pendingLeft = r ? r.scrollLeft : 0;
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(closeWindow, 900);
    }
    function closeWindow(){
      changing = false;
      closeTimer = null;
      var r = getRail();
      if (r) {
        var prevBehavior = r.style.scrollBehavior;
        r.style.setProperty('scroll-behavior', 'auto', 'important');
        r.scrollLeft = pendingLeft;
        requestAnimationFrame(function(){
          r.style.scrollBehavior = prevBehavior || '';
          revealRail(r);
        });
      }
    }
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t && t.matches && t.matches('.product-form__input input, fieldset.product-form__input--swatch input, fieldset.product-form__input--pill input')) {
        openWindow();
      }
    }, true);

    Element.prototype.scrollTo = function(opts){
      var isRail = this.classList && this.classList.contains('product__media-list');
      if (changing && isRail && opts && typeof opts.left === 'number') {
        pendingLeft = opts.left;
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(closeWindow, 350);
        return;
      }
      return origScrollTo.apply(this, arguments);
    };
  })();
})();
